export const TRANSFER_STATUS_PENDING = 'PENDING'
export const TRANSFER_STATUS_COMPLETED = 'COMPLETED'
export const TRANSFER_STATUS_INPROGRESS = 'INPROGRESS'